// third-party
import { APPLICATION_ROUTES } from 'constants/routes';
import { FormattedMessage } from 'react-intl';

// assets
import { IconChartPie, IconDashboard, IconDeviceAnalytics, IconCurrencyDollar, IconShoppingCart } from '@tabler/icons';

// type
import { NavItemType } from 'types';

const icons = {
    IconDashboard: IconDashboard,
    IconChartPie: IconChartPie,
    IconDeviceAnalytics: IconDeviceAnalytics,
    IconCurrencyDollar: IconCurrencyDollar,
    IconShoppingCart: IconShoppingCart
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const dashboard: NavItemType = {
    id: 'dashboard',
    title: <FormattedMessage id="dashboard" />,
    icon: icons.IconDashboard,
    type: 'group',
    children: [
        {
            id: 'Dashboard',
            title: <FormattedMessage id="Dashboard" />,
            type: 'item',
            url: APPLICATION_ROUTES.dashboard,
            icon: icons.IconChartPie,
            breadcrumbs: false
        },
        {
            id: 'Production Report',
            title: <FormattedMessage id="Production Report" />,
            type: 'item',
            url: APPLICATION_ROUTES.consolidatedReport,
            icon: icons.IconDashboard,
            breadcrumbs: false
        },
        {
            id: 'Operational P&L',
            title: <FormattedMessage id="Operational P&L" />,
            type: 'item',
            url: APPLICATION_ROUTES.operationalPLReport,
            icon: icons.IconDeviceAnalytics,
            breadcrumbs: false
        }
    ]
};

export default dashboard;
